<template>
  <a :type="type" :style="cssProps">
    <p class="link-txt">{{ text }}</p>
    <fa class="icon" :icon="icon" />
  </a>
</template>

<script>
export default {
  name: "Link",
  props: {
    text: {
      type: String,
      default: "Link",
    },
    type: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "var(--primary-clr)",
    },
    icon: {
      type: String,
      default: "code",
    },
  },
  computed: {
    cssProps() {
      let display = "none";
      if (this.icon !== "code") {
        display = "block";
      }
      return {
        "--icon-display": display,
        "--btn-clr": this.color,
      };
    },
  },
};
</script>

<style scoped>
* {
  font-size: 1rem;
}
a {
  border: none;
  background: var(--btn-clr);
  height: 2rem;
  border-radius: 3rem;
  box-shadow: 0 0 1rem 0.2rem rgba(126, 126, 126, 0.05);
  cursor: pointer;
  width: max-content;
  position: relative;
  overflow: hidden;
  transition: 0.5s ease;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

a::before {
  content: "";
  position: absolute;
  width: 0;
  aspect-ratio: 1;
  border-radius: 50%;
  background: var(--light-clr);
  opacity: 0.2;
  transition: 0.5s ease;
  /* justify-self: center;
  align-self: center; */
}

a:hover,
a:focus {
  box-shadow: 0 0 1rem 0.2rem rgba(0, 0, 0, 0.15);
}

a:hover::before,
a:focus::before {
  width: 110%;
}

.link-txt {
  color: white;
  font-weight: bold;
  font-size: 1em;
  padding: 0rem 1.5rem;
  width: max-content;
}
.icon {
  margin-inline-end: 1.5rem;
  margin-inline-start: -1em;
  color: white;
  display: var(--icon-display);
  width: 0.8em;
}

a:hover .icon,
a:focus .icon {
  transform: rotate(15deg) scale(1.2);
}

@media screen and (max-width: 30rem) {
  .link-txt {
    font-size: 1em;
  }
}
</style>
